import React from 'react'
import styled, { css } from 'styled-components'

const width = '42.9'
const height = '61.3'
const viewBox = '0 0 42.9 61.3'

const getDimensions = () => ({
  height,
  width
})

const getDimensionsCss = () => css`
  width: ${width}px;
  height: ${height}px;
`

const Image = styled.svg`
  ${({ noStyles }) => (!noStyles ? getDimensionsCss() : null)}
`

const defaultProps = {
  children: [
    <g key="key-0" transform="translate(23 22)">
      <path
        d="M-1.6-22C-13.4-22-23-12.4-23-.5c0 16.1 21.4 39.9 21.4 39.9S19.9 15.6 19.9-.5C19.9-12.4 10.3-22-1.6-22z"
        fill="#1E4F67"
      />
      <ellipse cx="-1.4" cy="-1" rx="10.3" ry="10.3" fill="#eef4f9" />
    </g>
  ],
  viewBox
}

export default Object.assign(Image, {
  getDimensions,
  getDimensionsCss,
  defaultProps,
  displayName: 'IconMapPinFlat'
})
